import Reveal from "@/components/Reveal";

export const PageHeader = ({ overline, title, subtitle, script }) => (
  <section className="relative pt-40 pb-16 bg-gradient-to-b from-mahogany-950 to-mahogany-900 overflow-hidden grain" data-testid="page-header">
    <div className="absolute inset-0 opacity-15" style={{ background: "radial-gradient(circle at 70% 20%, rgba(212,175,55,0.3), transparent 50%)" }} />
    <Reveal className="relative max-w-4xl mx-auto text-center px-6">
      {overline && <p className="overline mb-4">{overline}</p>}
      {script && <p className="font-script text-3xl sm:text-4xl text-fuchsia mb-2">{script}</p>}
      <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl font-light text-cream tracking-tight">{title}</h1>
      {subtitle && <p className="text-cream/70 text-lg mt-6 max-w-2xl mx-auto leading-relaxed font-light">{subtitle}</p>}
      <div className="w-20 h-px bg-gold mx-auto mt-8" />
    </Reveal>
  </section>
);

export default PageHeader;
